import React from 'react'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablasComunService from 'services/tablasComunes.service'

const TipoOperacionFormGroup = ({ value, onChange, vSeInventario }) => {
  const __zariContext = React.useContext(ZariContext)
  const [tiposOperacion, setTiposOperacion] = React.useState([])

  React.useEffect(() => {
    TablasComunService.getAsSelect(TiposTablaComunConstant.TIPOOPERACIONSUNAT)
      .then(({ data }) => {
        setTiposOperacion(data.filter(x => x._id !== '11' && x._id !== '21'))
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  return (
    <Form.Group>
      <Form.Label text='TIPO OPERACION' htmlFor='select-tipoOperacion' md={3} alignRightAt='md' />
      <Col md={9}>
        <Form.Select
          id='select-tipoOperacion'
          name='select-tipoOperacion'
          value={value}
          onChange={onChange}
        >
          <option value=''>Seleccionar</option>
          {tiposOperacion
            .filter(x => x.se === vSeInventario)
            .map((val, key) => (
              <option key={key} value={val._id}>
                {val.nombre}
              </option>
            ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoOperacionFormGroup)
